"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var microsoftTeams = require("@microsoft/teams-js");
var authentication_metadata_api_1 = require("../../api/authentication-metadata-api");
var SignInSimpleStart = function () {
    react_1.useEffect(function () {
        microsoftTeams.initialize();
        microsoftTeams.getContext(function (context) {
            var windowLocationOriginDomain = window.location.origin.replace("https://", "");
            var login_hint = context.upn ? context.upn : "";
            authentication_metadata_api_1.getAuthenticationConsentMetadata(windowLocationOriginDomain, login_hint).then(function (result) {
                window.location.assign(result.data);
            });
        });
    });
    return (React.createElement(React.Fragment, null));
};
exports.default = SignInSimpleStart;
//# sourceMappingURL=signin-start.js.map